/**
 * The marketing-consent wording, defined ONCE.
 *
 * ⚠ It appears in two places — the onboarding form and the billing page — and
 * they had drifted. Onboarding promised "you can unsubscribe at any time"
 * while billing described the scope of the consent instead. Two descriptions
 * of the same consent is the kind of difference a customer notices and a
 * regulator asks about, and nothing would ever have failed to warn us.
 *
 * ⚠ It describes the SCOPE of this consent, and deliberately does NOT promise
 * that account email exists. It used to read "you'll still get email about your
 * account, your jobs and your billing" — which told customers to expect service
 * email AcuTidy has never been able to send. Somebody could reasonably have
 * waited for a job-completion email that was never coming.
 *
 * The unsubscribe promise is gone from the moment of consent for the same
 * reason: marketing will go out through Mailchimp, which handles unsubscribe
 * natively, but nothing sends today and no unsubscribe path exists in this
 * product. Promising a mechanism at the instant someone opts in is the worst
 * place to be approximately right.
 *
 * If system email is built, both of these can go back to describing it.
 */
export const MARKETING_CONSENT_LABEL =
  'Email me occasional product updates from AcuTidy and DLG Services, Inc.';

export const MARKETING_CONSENT_SCOPE =
  'We never sell or share your address. This covers product news only — it ' +
  'does not affect anything to do with your account, your jobs or your billing.';
